// extracted by mini-css-extract-plugin
export var Section = "News-module--Section--9akBh";
export var LangHY = "News-module--LangHY--TifJu";
export var ItemDesc = "News-module--ItemDesc--w1kNg";
export var ItemMeta = "News-module--ItemMeta--hBbfi";
export var Item = "News-module--Item--BFDdr";
export var Line = "News-module--Line--Gg6jx";
export var ItemLink = "News-module--ItemLink--qKJYT";
export var ItemImage = "News-module--ItemImage--heEsK";
export var ItemImageHorizontal = "News-module--ItemImageHorizontal---Psdv";
export var ItemContent = "News-module--ItemContent--j93qn";
export var ItemTitle = "News-module--ItemTitle--kATyr";
export var ItemFooter = "News-module--ItemFooter--2ObxQ";
export var Btn = "News-module--Btn--GB0XH";
export var arrowLeft = "News-module--arrowLeft--m2Iut";
export var arrowRight = "News-module--arrowRight--r-0ug";